import React from "react";
import PropTypes from "prop-types";
import {
  TextField,
  Checkbox,
  FormGroup,
  MenuItem,
  Grid,
  FormControlLabel
} from "@material-ui/core";

import { COUNTRIES } from "../../../../../const";
const ParentForm = props => {
  const {
    setFieldValue,
    values,
    handleChange,
    index,
    touched,
    errors,
    handleBlur,
    style
  } = props;

  return (
    <div>
      <h5>{`Parent ${Number(index) + 1} Informations`}</h5>
      <Grid container spacing={24}>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={`Nom *`}
              name={`parents[${index}][nom]`}
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched[`parents[${index}][nom]`] &&
                    errors[`parents[${index}][nom]`]}
                </span>
              }
              value={values[`parents[${index}][nom]`]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={`Prénom *`}
              name={`parents[${index}][prenom]`}
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched[`parents[${index}][prenom]`] &&
                    errors[`parents[${index}][prenom]`]}
                </span>
              }
              value={values[`parents[${index}][prenom]`]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                name={`parents[${index}].usingKidAddress`}
                checked={values.parents[index].usingKidAddress}
                onChange={() => {
                  setFieldValue(
                    `parents[${index}].usingKidAddress`,
                    !values.parents[index].usingKidAddress
                  );
                  setFieldValue(
                    `parents[${index}][adresseDto][rue]`,
                    values.adresseDto.rue
                  );
                  setFieldValue(
                    `parents[${index}][adresseDto][ville]`,
                    values.adresseDto.ville
                  );
                  setFieldValue(
                    `parents[${index}][adresseDto][codePostale]`,
                    values.adresseDto.codePostale
                  );
                  setFieldValue(
                    `parents[${index}][adresseDto][pays]`,
                    values.adresseDto.pays
                  );
                }}
              />
            }
            label="Utilisez l'adresse de l'enfant"
          />
        </Grid>
        <Grid item xs={8}>
          <FormGroup>
            <TextField
              label="Rue *"
              variant="outlined"
              disabled={values.parents[index].usingKidAddress}
              name={`parents[${index}][adresseDto][rue]`}
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.parents &&
                    touched.parents[index] &&
                    touched.parents[index]["adresseDto"] &&
                    touched.parents[index]["adresseDto"]["rue"] &&
                    errors.parents &&
                    errors.parents[index] &&
                    errors.parents[index]["adresseDto"] &&
                    errors.parents[index]["adresseDto"]["rue"]}
                </span>
              }
              value={values.parents[index]["adresseDto"]["rue"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={4}>
          <FormGroup>
            <TextField
              label="Ville *"
              variant="outlined"
              disabled={values.parents[index].usingKidAddress}
              name={`parents[${index}]["adresseDto"]["ville"]`}
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.parents &&
                    touched.parents[index] &&
                    touched.parents[index]["adresseDto"] &&
                    touched.parents[index]["adresseDto"]["ville"] &&
                    errors.parents &&
                    errors.parents[index] &&
                    errors.parents[index]["adresseDto"] &&
                    errors.parents[index]["adresseDto"]["ville"]}
                </span>
              }
              value={values.parents[index]["adresseDto"]["ville"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label="Code Postale *"
              variant="outlined"
              disabled={values.parents[index].usingKidAddress}
              name={`parents[${index}]["adresseDto"]["codePostale"]`}
              type="number"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.parents &&
                    touched.parents[index] &&
                    touched.parents[index]["adresseDto"] &&
                    touched.parents[index]["adresseDto"]["codePostale"] &&
                    errors.parents &&
                    errors.parents[index] &&
                    errors.parents[index]["adresseDto"] &&
                    errors.parents[index]["adresseDto"]["codePostale"]}
                </span>
              }
              value={values.parents[index]["adresseDto"]["codePostale"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              select
              disabled={values.parents[index].usingKidAddress}
              label="Pays "
              variant="outlined"
              name={`parents[${index}]["adresseDto"]["pays"]`}
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.parents &&
                    touched.parents[index] &&
                    touched.parents[index]["adresseDto"] &&
                    touched.parents[index]["adresseDto"]["pays"] &&
                    errors.parents &&
                    errors.parents[index] &&
                    errors.parents[index]["adresseDto"] &&
                    errors.parents[index]["adresseDto"]["pays"]}
                </span>
              }
              value={values.parents[index]["adresseDto"]["pays"]}
            >
              {COUNTRIES.map(country => (
                <MenuItem key={country} value={country}>
                  {country}
                </MenuItem>
              ))}
            </TextField>
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={`Email *`}
              name={`parents[${index}][email]`}
              type="email"
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched[`parents[${index}][email]`] &&
                    errors[`parents[${index}][email]`]}
                </span>
              }
              value={values.parents[index]["email"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={`Téléphone *`}
              name={`parents[${index}][numeroTel]`}
              type="number"
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched[`parents[${index}][numeroTel]`] &&
                    errors[`parents[${index}][numeroTel]`]}
                </span>
              }
              value={values.parents[index]["numeroTel"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              select
              label="Sexe "
              variant="outlined"
              name={`parents[${index}].sexe`}
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.parents[index]["sexe"]}
            >
              <MenuItem key="M" value="Masculin">
                Masculin
              </MenuItem>
              <MenuItem key="F" value="Feminin">
                Feminin
              </MenuItem>
            </TextField>
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              select
              label="Situation "
              variant="outlined"
              name={`parents[${index}].situation`}
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.parents[index]["situation"]}
            >
              <MenuItem key="M" value="Marié">
                Marié
              </MenuItem>
              <MenuItem key="C" value="Célibataire">
                Célibataire
              </MenuItem>
              <MenuItem key="D" value="Divorcé">
                Divorcé
              </MenuItem>
              <MenuItem key="V" value="Veuf">
                Veuf
              </MenuItem>
            </TextField>
          </FormGroup>
        </Grid>
      </Grid>
    </div>
  );
};

ParentForm.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  touched: PropTypes.object,
  style: PropTypes.object
};

export default ParentForm;
